import { useSearchContext } from '@contexts/SearchContext';
import { ReactElement } from 'react';
import { Form, Icon, Input } from './SearchInput.styles';

export interface SearchInputProps {
  title: string;
}

export const SearchInput = ({ title }: SearchInputProps): ReactElement => {
  const { search, setSearch } = useSearchContext();

  const handleChange = (event) => {
    setSearch(event.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Icon />

      <Input
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus
        id="search"
        type="text"
        placeholder={title}
        value={search}
        onChange={handleChange}
      />
    </Form>
  );
};
